export  function RemoverZeroAEsquerda(a) {
    return +a
} 

export function FormatarData(a) {
    //a = 123456
    if (a && a.length == 6) {
        return `${a.substring(0, 2)}/${a.substring(2, 4)}/${a.substring(4, 6)}`
    }
    return "A"
}

export function FormataDinheiro(dinheiroInput) {
    if (typeof dinheiroInput == "number") {
        dinheiroInput = parseFloat(dinheiroInput).toFixed(2).toString();
        return "R$ " + dinheiroInput.replace(".", ',');
    } else {
        return "R$ " + dinheiroInput;
    }
}

export function UppercaseIt(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}